<template>
  <div
    class="upload-dialog"
    :style="{bottom: dialogBottom +'px'}"
  >
    <div class="bar-title clearfix">
      <div class="max-title f-l clearfix">
        <!--                <span id="upload-title">{{$t(dialogTitle)+'('+fileIndex+'/'+uploadInfo[0].length+')'}}</span>-->
        <span id="upload-title">{{ $t(dialogTitle) }}</span>
        <span
          v-show="(dialogTitle === '正在上传' || remainingTime !== '0s') && !hasCancel"
          id="total-count"
        >
          {{ $t('剩余时间') }}：{{ remainingTime }}
        </span>
        <span id="upload-progress" />
      </div>
      <div class="f-r op">
        <span
          id="close-upload-task-list"
          @click="close"
        />
        <span
          id="set-size"
          :class="minDialog?'set-large':'set-min'"
          @click="minDialog = !minDialog"
        />
      </div>
    </div>
    <div class="task-title">
      <div class="f-l file">
        {{ $t('文件名') }}
      </div>
      <!--            <div class="f-l progress">{{$t('进度')}}</div>-->
      <div class="f-l size">
        {{ $t('大小') }}
      </div>
      <div class="f-l time">
        {{ $t('上传至') }}
      </div>
      <div class="f-l">
        <a
          class="btn cancel-all"
          :class="{'disabled': hasCancel}"
          href="javascript:;"
          @click="cancelUpload('all')"
        >{{ $t('取消所有') }}</a>
      </div>
    </div>
    <div class="upload-scroll-wrapper ">
      <div
        v-for="(item, index) in uploadInfo[0]"
        :key="index"
        class="task-file list-wrapper"
        :class="{error: errState[index] || item.file.error}"
      >
        <svg class="f-l file-icon icon-file">
          <use
            ref="fileicon"
            :xlink:href="'#'+getFileIcon(item)"
          />
        </svg>
        <!--                <div class="f-l file-icon icon-file" :class="getFileIcon(item)"></div>-->
        <div
          class="f-l filename"
          :title="$t(item.file.name)"
          :class="{error: errState[index]}"
        >
          {{ item.file.name }}
        </div>
        <div
          class="f-l progress"
          :title="$t(uploadStatus[index].progress)"
        >
          {{ errState[index] && !item.file.warnTxt ? $t('已取消') : $t(uploadStatus[index].size) }}
        </div>
        <!--                <div class="f-l size">{{errState[index] ? '' : $t(uploadStatus[index].size)}}</div>-->
        <div
          class="f-l time path"
          :title="item.path"
        >
          {{ item.path }}
        </div>
        <div class="opBox">
          <a
            class="cancelUploadBtn f-l op-btn"
            :class="[errState[index] ? 'upload-Cancel' :uploadStatus[index].op]"
            href="javascript:;"
            @click.stop="cancelUpload(index)"
          />
        </div>
        <span
          v-if="uploadStatus[index].progress !== '已完成' && !errState[index]"
          :style="{'width': uploadStatus[index].progress}"
          class="current-progress"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as Util from 'js/util/util.js'

export default {
  props: {
    uploadInfo: Array,
    fileIndex: Number,
    totalSize: Number,
  },
  data() {
    return {
      minDialog: false,
      errState: [],
      dialogTitle: '正在上传',
      statusList: [],
      hasCancel: false,
    }
  },
  computed: {
    dialogBottom() {
      return this.minDialog ? -375 : 0
    },
    remainingTime() {
      let v = 1 // 速度
      const size = this.totalSize
      let loaded = 0 // 已上传部分大小
      for (let i = 0; i < this.uploadInfo[0].length; i++) {
        if (this.uploadInfo[0][i].remaining) {
          if (!this.uploadInfo[0][i].remaining.loaded) {
            loaded += this.uploadInfo[0][i].file.size
          } else {
            loaded += this.uploadInfo[0][i].remaining.loaded
          }
          if (this.uploadInfo[0][i].remaining.speed) {
            v = this.uploadInfo[0][i].remaining.speed > v
              ? this.uploadInfo[0][i].remaining.speed
              : v // 为保持上传剩余时间稳定显示，取最大上传速度
          }
        }
      }
      if (loaded === 0) return '0s'
      return this.resultFormat(Math.round((size - loaded) / 1024 / v))
    },
    uploadStatus() {
      const status = this.uploadInfo[0]
      this.statusList = []
      for (let i = 0; i < status.length; i++) {
        if (!status[i].progressEvent) {
          let progress = '排队中'; let size = `/${Util.formatBytes(status[i].file.size)}`; let op = 'upload-cancel'; const
            remaining = ''
          if (status[i].file && status[i].file.warnTxt) {
            progress = status[i].file.warnTxt
            size = status[i].file.warnTxt
            op = 'upload-Cancel'
            this.errState[i] = true
          }
          this.statusList.push({
            size, progress, op, remaining,
          })
          continue
        }

        let progress = `${Math.round((status[i].progressEvent.loaded / status[i].progressEvent.total) * 100)}%`
        let size = `${Util.formatBytes(status[i].progressEvent.loaded)}/${Util.formatBytes(status[i].progressEvent.total)}`
        let op = 'upload-cancel'
        let { remaining } = status[i]
        if (progress === '100%') {
          progress = size = '已完成'
          op = 'upload-success'
          remaining = ''
        }
        if (this.errState[i]) {
          progress = '已取消'
          size = '已取消'
          op = 'upload-Cancel'
          remaining = ''
        }
        this.statusList.push({
          size, progress, op, remaining,
        })
      }
      return this.statusList
    },
  },
  methods: {
    resultFormat(result) { // 格式化计算好的剩余时间
      const h = parseInt(result / 60 / 60 % 24, 10)
      const m = parseInt(result / 60 % 60, 10)
      const s = result - h * 60 * 60 - m * 60
      if (result < 60) {
        return `${result}s`
      } if (h < 1) {
        return `${m}m${s}s`
      }
      return `${h}h${m}m${s}s`
    },
    getFileIcon(data) {
      const file_i = Util.resolvePath(`/${data.file.name}`, false)
      return Util.typeIcon(file_i.type)
    },
    close() {
      this.$emit('closeUploadEL')
    },
    cancelUpload(index) {
      this.$emit('cancelUpload', index)

      if (index === 'all') {
        for (let i = 0; i < this.uploadInfo[0].length; i++) {
          if (this.statusList[i].progress === '100%' || this.statusList[i].progress === '已完成') continue
          this.errState[i] = true
        }
        return
      }
      this.errState[index] = true
      this.hasCancel = true
    },
  },
}
</script>

<style lang="less">
.upload-dialog{
  width: 700px;
  height: 414px;
  position: fixed;
  right: 52px;
  font-family: "microsoft yahei";
  font-size: 14px;
  color: #1B2733;
  z-index: 30;
  box-shadow: rgb(204, 204, 204) 0px 0px 7px;
  background: rgb(255, 255, 255);
  border-width: 1px;
  border-style: solid;
  border-color: rgb(210, 210, 210);
  transition: bottom 0.5s;
  .f-l{
    float: left;
  }
  .f-r {
    float:right;
  }
  .max-title{
    height: 100%;
    line-height: 27px;
  }
  .bar-title {
    // height: 43px;
    // line-height: 43px;
    position: relative;
    background-color: #ffffff;
    color: #1B2733;
    padding: 12px;
    box-sizing: border-box;
    .op span{
      float: right;
      /*background: url(../../../static/image/dialog-operate.png);*/
      vertical-align: middle;
    }
    .op span#set-size{
      width: 27px;
      height: 27px;
      margin-right: 12px;
      display: inline-block;
      cursor: pointer;
      border-radius: 13px;
      background-position: 6px;
    }
    .op span.set-min{
      background: url(~image/min.svg) no-repeat;
      background-position-y: 8px;
    }
    .op span.set-large{
      background: url(~image/large.svg) no-repeat;
    }
    .op #close-upload-task-list{
      width: 27px;
      height: 27px;
      background: url(~image/close.svg) no-repeat;
      display: inline-block;
      cursor: pointer;
      background-position: 6px;
      border-radius: 13px;
    }
    .op #close-upload-task-list:hover{
      background-color: #f6f7fa;
    }
    .op span:hover {
      background-color: #f6f7fa;
    }
  }
  .task-title{
    height: 30px;
    line-height: 30px;
    font-size:14px;
    color: #1B2733;
    border-bottom: 2px #F3F3F3 solid;
  }
  .file{
    margin-left: 21px;
    width: 210px;
  }
  .progress{
    width: 128px;
    overflow: hidden;
    white-space:nowrap;
    margin-left: 6px;
    text-overflow: ellipsis;
  }
  .progress.error{
    width: 267px;
  }
  .size{
    width: 128px;
    height: 100%;
    overflow: hidden;
    white-space:nowrap;
    margin-left: 6px;
  }
  .action{
    width: 102px;
    height: 100%;
  }
  .state{
    width: 130px;
    height: 100%;
  }
  .cancel-all{
    text-decoration: none;
    color: #157bf8;
    font-size: 14px;
  }
  .pause-all{
    margin-left: 10px;
  }
  .time{
    width: 256px;
    height: 100%;
    text-align:left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    color: #1b2733;
    padding: 0 6px;
    box-sizing: border-box;
  }
  .path{
    direction: rtl;
  }
  .upload-scroll-wrapper{
    width: 100%;
    height: 82%;
    overflow: scroll;
    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    &::-webkit-scrollbar-thumb  {
      opacity: 0.6;
      background: #C1C7CD;
      border-radius: 100px;
    }
    .task-file {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px #F3F3F3 solid;
      position: relative;
      clear: both;
      color: #949494;
      font-size: 12px;
      .current-progress{
        position: absolute;
        height: 50px;
        top: 0;
        left: 0;
        background-color: #dae8ff;
        z-index: -1;
      }
    }
    .file-icon {
      margin: 12px 0 0 20px;
      width: 24px;
      height: 26px;
    }
    .filename {
      color: #1B2733;
      margin-left: 15px;
      width: 172px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .opBox {
      height: 100%;
      padding-left: 12px;
      box-sizing: border-box;
      float: left;
      a{
        width: 17px;
        height: 17px;
        margin-top: 16px;
      }
      .upload-cancel {
        background: url(~image/sprite-operate-btn.png) no-repeat;
        cursor: pointer;
      }
      .upload-cancel {
        background-position: -3px -46px;
      }
      .upload-error, .upload-success, .upload-Cancel{
        cursor: default;
      }
      .upload-error {
        background: url(~image/warn.svg) no-repeat;
      }
      .upload-success {
        background: url(~image/success.svg) no-repeat;
      }
      .upload-Cancel {
        /*background: url(~image/warn.png) no-repeat;*/
      }
    }
    .error {
      color: #929CA9;
      div{
        color: #929CA9;
      }
    }
  }
  .disabled{
    color: #bcbcbc;
    pointer-events:none;
  }
}
</style>
